import { DisplaySettingsOutlined } from "@mui/icons-material";
import RffBooleanToggleField from "../../components/finalForm/inputs/RffBooleanToggleField";
import RffDateField from "../../components/finalForm/inputs/RffDateField";
import RffDollarField from "../../components/finalForm/inputs/RffDollarField";
import RffFloatField from "../../components/finalForm/inputs/RffFloatField";
import RffSelectField from "../../components/finalForm/inputs/RffSelectField";
import RffTextField from "../../components/finalForm/inputs/RffTextField";
import RffConditional from "../../components/finalForm/shared/RffConditional";
import RffGroup from "../../components/finalForm/shared/RffGroup";
import TitledLoanSection from "./TitledLoanSection";
import RffSelectRadioField from "../../components/finalForm/inputs/RffSelectRadioField";
import { selectOptionsLoanProductType } from "../../constants/selectOptions/selectOptionsLoanProductType";
import { selectOptionsLoanPurpose } from "../../constants/selectOptions/selectOptionsLoanPurpose";
import RffSelectToggleField from "../../components/finalForm/inputs/RffSelectToggleField";
import RffSelectAutocompleteField from "../../components/finalForm/inputs/RffSelectAutocompleteField";
import Flx from "../../components/layout/Flx";
import Htag from "../../components/typography/Htag";
import Txt from "../../components/typography/Txt";
import FlxGrid from "../../_src_shared/components/layout/FlxGrid";
import RffEmailField from "../../components/finalForm/inputs/RffEmailField";
import RffPhoneField from "../../components/finalForm/inputs/RffPhoneField";
import RffTextareaField from "../../components/finalForm/inputs/RffTextareaField";

const LoanDetailSection = ({ testing, returnChildrenOnly }) => {
  return (
    <TitledLoanSection
      // icon={<InfoOutlined className="thin" />}
      icon={<DisplaySettingsOutlined className="thin" />}
      variant="h2"
      title="Loan Details"
      collapsable
      returnChildrenOnly={returnChildrenOnly}
    >
      <RffGroup suppressBottomMargin>
        <RffSelectAutocompleteField
          required
          name="loanProductType"
          label="Loan Product Type"
          options={[
            "DSCR",
            "Fix and Flip",
            "Ground Up Construction",
            "Stabilized Bridge",
          ]}
          size={6}
        />
        <RffSelectAutocompleteField
          name="loanPurpose"
          label="Loan Purpose"
          required
          size={6}
          options={selectOptionsLoanPurpose}
        />
        <RffConditional
          testing={testing}
          operatorForMultiple={"OR"}
          rules={[
            {
              field: "loanProductType",
              operator: "==",
              value: "Fix and Flip",
            },
            {
              field: "loanProductType",
              operator: "==",
              value: "Ground Up Construction",
            },
            {
              field: "loanProductType",
              operator: "==",
              value: "Vacant Land",
            },
          ]}
        >
          <RffDollarField
            // size={6}
            name="baseLoanAmount"
            label="Initial loan amount"
            helperText="Amount before any draws"
          />
        </RffConditional>

        {/* <RffSelectToggleField
          name="exitStrategy"
          label="Exit Strategy"
          placeholder="Explain how the borrower plans to repay or exit this loan"
          // minHeight={80}
          options={[
            "Sell after renovation",
            "Refinance - Hold as rental",
            "Other",
          ]}
        /> */}
        <RffTextareaField
          name="exitStrategy"
          label="Exit Strategy"
          placeholder="Explain how the borrower plans to repay or exit this loan"
          minHeight={80}
        />

        {/* <RffDateField
          name="expectedClosingDate"
          label="What is the expected closing date for the loan?"
          required={testing?.required}
        /> */}

        <RffConditional field="loanProductType" value="DSCR">
          <RffFloatField
            name="dscr"
            //
            label="The DSCR for the loan as measured by counterparty"
            // label="DSCR"
          />
          <RffDollarField
            name="totalInPlaceRents"
            size={6}
            label="Total In Place Rents"
            helperText="The total rents for the loan for all properties and all units per property"
          />
          <RffDollarField
            name="totalMarketRents"
            size={6}
            label="Total Market Rents"
            helperText="The total market rents for the loan for all properties and all units per property"
          />
        </RffConditional>

        <RffConditional
          testing={testing}
          operatorForMultiple={"OR"}
          rules={[
            {
              field: "loanProductType",
              operator: "==",
              value: "Stabilized Bridge",
            },
            {
              field: "loanProductType",
              operator: "==",
              value: "30-Year Rental Loan",
            },
            {
              field: "loanProductType",
              operator: "==",
              value: "Other",
            },
            {
              field: "loanProductType",
              operator: "==",
              value: "Foreclosure Bail Out",
            },
            {
              field: "loanProductType",
              operator: "==",
              value: "DSCR",
            },
          ]}
        >
          <RffDollarField name="baseLoanAmount" label="Requested Loan Amount" />
        </RffConditional>
      </RffGroup>
      <RffConditional
        testing={testing}
        field="loanPurpose"
        operator="includes"
        value={[
          "Refinance - No Cash Out",
          "Refinance - Cash Out",
          "Delayed Purchase",
        ]}
      >
        <RffGroup
          titleType="h3"
          sx={{ mt: 6 }}
          title="Refinanced Details"
          suppressBottomMargin
        >
          <RffConditional
            testing={testing}
            field="loanPurpose"
            operator="includes"
            value={[
              "Refinance - No Cash Out",
              "Refinance - Cash Out",
              "Delayed Purchase",
            ]}
          >
            <RffDollarField
              name="outstandingLoanUpb"
              label="Total principal amount of outstanding loan (this would be your expected payoff) :"
            />

            <RffTextField
              name="exisitingLender"
              label="What is the name of the current lender?"
            />
            <RffDateField
              name="existingLoanMaturityDate"
              label="Maturity date of existing loan :"
            />
            <RffBooleanToggleField
              name="existingLoanLatePayments"
              label="Have there ever been any payments made more than 30-days from due date on the existing loan?"
            />
            <RffBooleanToggleField
              name="existingLoanInDefault"
              label="Is the current loan in default (either payment or maturity default)?"
            />
            <RffConditional
              testing={testing}
              field="existingLoanInDefault"
              value={true}
            >
              <RffSelectField
                name="existingLoanDefaultType"
                label="Select existing loan default type:"
                options={["Maturity Default", "Payment Default"]}
              />
            </RffConditional>
            <RffBooleanToggleField
              name="existingLoanHasUndrawnBudget"
              label="Existing Loan Has Undrawn Budget"
            />
            <RffConditional
              testing={testing}
              field="existingLoanUndrawnBudgetAmount"
              value={true}
            >
              <RffDollarField
                name="existingLoanUndrawnBudgetAmount"
                label="Existing Loan Undrawn Budget Amount"
              />
            </RffConditional>
            <RffBooleanToggleField
              name="propertyListedForSale"
              label="Is the property currently listed for sale?"
            />
          </RffConditional>
          <RffConditional
            testing={testing}
            field="loanPurpose"
            operator="includes"
            value={["Refinance - No Cash Out", "Refinance - Cash Out"]}
          >
            <RffBooleanToggleField
              name="propertyListedForSaleLastSixMonths"
              label="Has the property been listed for sale in the last six months?"
            />
          </RffConditional>
        </RffGroup>
      </RffConditional>
      <RelatedPOC />
    </TitledLoanSection>
  );
};
const LOAN_CONTACT_ROLES = [
  "Appraisal Point of Contact",
  "Title Agent",
  "Insurance Agent",
];

const RelatedPOC = () => {
  return (
    <Flx column g={2} sx={{ mb: 0, mt: 8 }}>
      <Htag h2>Loan Related Contacts</Htag>
      <Flx column fw gap={6}>
        {LOAN_CONTACT_ROLES.map((role, index) => (
          <Flx column g={1} key={role}>
            <Txt>{role}</Txt>
            <FlxGrid grow={1} width="140px" gap={2}>
              <RffTextField
                inlineLabel
                suppressGrid
                name={`loanRelatedContacts[${index}].firstName`}
                label="First Name"
                size={6}
              />
              <RffTextField
                inlineLabel
                suppressGrid
                name={`loanRelatedContacts[${index}].lastName`}
                label="Last Name"
                size={6}
              />
              <RffEmailField
                inlineLabel
                size={6}
                suppressGrid
                name={`loanRelatedContacts[${index}].emailAddress`}
                label="Email"
              />
              <RffPhoneField
                inlineLabel
                suppressGrid
                name={`loanRelatedContacts[${index}].phone`}
                size={6}
                label="Phone"
              />
            </FlxGrid>
          </Flx>
        ))}
      </Flx>
    </Flx>
  );
};
export default LoanDetailSection;
